import script from "./Campaign.vue?vue&type=script&lang=ts&setup=true"
export * from "./Campaign.vue?vue&type=script&lang=ts&setup=true"

import "./Campaign.vue?vue&type=style&index=0&id=47bba313&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47bba313"]])

export default __exports__